<div class="wrap">
  <ng-container *ngIf="!isCreationMode && !isFileMode && !isSessionMode">
    <div class="header">
      <div class="title">
        <fa-icon [icon]="getFaIcon('faChevronLeft')" (click)="goBack()" appChangeColorTheme attribute="color">
        </fa-icon>
        <h2>{{club?.clubName}}</h2>
      </div>
      <div class="update_club">
        <fa-icon [icon]="getFaIcon('faEdit')" [matTooltip]="getTooltip('clubDetailUpdate')"
          (click)="openDialogUpdateClub('update')" appChangeColorTheme attribute="color">
        </fa-icon>
      </div>
    </div>

    <div class="infos_club">

      <ng-container *ngIf="!isLoadingClubDetails">
        <app-contact-address [club]="club"></app-contact-address>
        <app-discount [clubCode]="clubCode"></app-discount>
      </ng-container>
      <mat-spinner *ngIf="isLoadingClubDetails" [diameter]="75"></mat-spinner>

      <div class="practice_place_priority_offer">
        <ng-container *ngIf="!isLoadingClubDetails">
          <app-practice-place [userConnected]="userConnected"></app-practice-place>
          <app-pirority-offer [club]="club" [clubCode]="clubCode" [userConnected]="userConnected"></app-pirority-offer>
        </ng-container>
        <mat-spinner *ngIf="isLoadingClubDetails" [diameter]="75"></mat-spinner>
      </div>

    </div>


    <div class="offers" *ngIf="!isLoading">

      <div class="header_offer">

        <div class="tabs">
          <div [ngClass]="{tab_active: tab ==='offers', tab: tab !== 'offers'}" (click)="selectTab('offers')">
            Vitrine (offres)
          </div>

          <div [ngClass]="{tab_active: tab ==='closedBooking', tab: tab !== 'closedBooking'}"
            (click)="selectTab('closedBooking')">
            Paniers en cours
          </div>

        </div>

        <div class="add_search_offer">
          <div class="add_offer" (click)="addOffer()" *ngIf="!isLoadingClubDetails && tab === 'offers'"
            appChangeColorTheme attribute="color">
            <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
            <span>Ajouter une offre</span>
          </div>
          <mat-spinner *ngIf="isLoadingClubDetails" [diameter]="25"></mat-spinner>
          <div class="search_bar">
            <form [formGroup]="searchForm">
              <input type="text" [placeholder]="getPlaceholderInputSearch()" (input)="applyFilter($event.target.value)"
                formControlName="keyword">
            </form>

            <fa-icon [icon]="valueInput ? getFaIcon('faTimes') : getFaIcon('faSearch')"
              (click)="valueInput? resetSearch(): null"></fa-icon>
          </div>
        </div>

      </div>

      <ng-container [ngSwitch]="tab">

        <div class="offers_club" *ngSwitchCase="'offers'">
          <app-table-offers-club *ngIf="tab ==='offers'" [offers]="offers" [clubCode]="clubCode"
            [valueSearch]="valueInput" [club]="club" (offerPreviewUpdate)="changeOfferPreview($event)"
            (onEdit)="onEdit($event)" (imageUpdate)="imageUpdate=$event" (switchToSession)="switchToSessionView($event)"
            (switchToFiles)="switchToFilesView($event)" (refreshOffers)="getClub()">
          </app-table-offers-club>
          <app-admin-preview-offer [offerPreview]="offerPreview" [imageUpdate]="imageUpdate"></app-admin-preview-offer>
        </div>

        <app-table-offer-inprogress *ngSwitchCase="['closedBooking' ,'basket'].includes(tab)? tab : '' "
          [valueSearch]="valuefilterSelected" [tab]="tab"></app-table-offer-inprogress>
      </ng-container>

    </div>

    <mat-spinner *ngIf="isLoading" [diameter]="50" style="margin: 0 auto;"></mat-spinner>
  </ng-container>

  <div *ngIf="isCreationMode || isSessionMode || isFileMode" class="content" [style.grid-template-columns]="'1fr 35%'">
    <ng-container *ngIf="isCreationMode">
      <app-admin-offer-edit [offer]="offerToEdit ?? null" (editFinished)="onEditFinished($event)"
        (offerPreviewUpdate)="changeOfferPreview($event)" (imageUpdate)="imageUpdate=$event"
        (switchToSession)="switchToSessionView($event)"></app-admin-offer-edit>
    </ng-container>

    <ng-container *ngIf="isSessionMode">
      <app-admin-offer-session [offer]="offerToEdit" (editFinished)="onEditFinished($event)"></app-admin-offer-session>
    </ng-container>

    <ng-container *ngIf="isFileMode">
      <app-admin-offer-file [offerKey]="offerToEdit.offerKey"
        (editFinished)="onEditFinished($event)"></app-admin-offer-file>
    </ng-container>

    <app-admin-preview-offer [offerPreview]="offerPreview" [imageUpdate]="imageUpdate"></app-admin-preview-offer>
  </div>
</div>